<div style="max-height: 7rem;"[ngClass]="this.temaPadrao">
<router-outlet></router-outlet>
</div>
